/* eslint-disable import/prefer-default-export */
import actionTypes from 'src/constants/actionTypes';
import aiService from 'src/services/ai';

export function generateQuestionsFromFile(values) {
  return dispatch => {
    dispatch({ type : actionTypes.AI__GENERATE_FROM_FILE_START });

    return aiService.generateQuestionsFromFile(values)
      .then(data => {
        const key = Object.keys(data)[0];

        return dispatch({
          type    : actionTypes.AI__GENERATE_FROM_FILE_SUCCESS,
          payload : { data : data[key] },
        });
      })
      .catch(errors => dispatch({
        type    : actionTypes.AI__GENERATE_FROM_FILE_FAILURE,
        payload : { errors },
      }));
  };
}
